"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SigninWithAppleButton = void 0;
const react_1 = __importStar(require("react"));
require("./SigninWithAppleButton.scss");
const SigninWithAppleButton_scss_json_1 = __importDefault(require("./SigninWithAppleButton.scss.json"));
const core_1 = require("@capacitor/core");
const Button_1 = require("lincd-mui-base/lib/components/Button");
const ClassNames_1 = require("lincd/lib/utils/ClassNames");
const useAuth_1 = require("lincd-auth/lib/hooks/useAuth");
const SigninWithAppleButton = ({ label = 'Sign in with Apple', // default text button
scopes = 'profile email name', // default scopes permission
className, // additional CSS classNames to apply to the button
onCallback, // callback function invoked when the authentication is successful.
onLoadingChange, // callback function invoked when the loading state changes, you can pass a function to handle the loading state when call the server
restProps, firebaseConfig, }) => {
    const [appleSignInModule, setAppleSignInModule] = (0, react_1.useState)(null);
    const [loading, setLoading] = (0, react_1.useState)(false); // loading spinner
    const auth = (0, useAuth_1.useAuth)();
    (0, react_1.useEffect)(() => {
        // Dynamically import the module inside useEffect
        if (core_1.Capacitor.getPlatform() === 'ios') {
            Promise.resolve().then(() => __importStar(require('@capacitor-community/apple-sign-in'))).then((module) => {
                setAppleSignInModule(module);
            })
                .catch((error) => {
                console.error('Error importing module:', error);
            });
        }
    }, []);
    const signInWithApple = () => {
        setLoading(true);
        if (core_1.Capacitor.getPlatform() === 'web') {
            // SignInWithAppleWeb();
            // console.log('response', response);
            // if (response && response.user) {
            //   auth
            //     .signinOAuth('apple', response.user)
            //     .then((response) => {
            //       if (onCallback) {
            //         onCallback(response);
            //       }
            //     })
            //     .catch((err) => {
            //       console.error('signin with apple failed:', err);
            //     });
            // }
        }
        else if (core_1.Capacitor.getPlatform() === 'ios') {
            const { SignInWithApple } = appleSignInModule;
            const options = {
                clientId: process.env.APP_ID,
                redirectURI: '',
                scopes: scopes,
                nonce: 'nonce',
            };
            SignInWithApple.authorize(options)
                .then((result) => {
                if (result && result.response && result.response.identityToken) {
                    // if onLoadingChange prop is passed, invoke it with true
                    if (onLoadingChange) {
                        onLoadingChange(true);
                    }
                    // call the server to sign in with apple
                    auth
                        .signinOAuth('apple', result.response)
                        .then((response) => {
                        // if response has an error, set all loading to false
                        if (response.error) {
                            setLoading(false);
                            if (onLoadingChange) {
                                onLoadingChange(false);
                            }
                        }
                        if (onCallback) {
                            onCallback(response);
                        }
                    })
                        .catch((err) => {
                        setLoading(false);
                        console.error('signin with apple failed:', err);
                    });
                }
            })
                .catch((err) => {
                setLoading(false);
                console.warn('signin with apple error', err);
            });
        }
    };
    // make sure button show only on ios platform
    // TODO: later will add support for web
    if (core_1.Capacitor.getPlatform() !== 'ios') {
        return null;
    }
    return (react_1.default.createElement(Button_1.Button, Object.assign({ className: (0, ClassNames_1.cl)(SigninWithAppleButton_scss_json_1.default.root, className), onClick: signInWithApple, variant: "outlined", fullWidth: true, disabled: loading, startIcon: react_1.default.createElement("svg", { className: SigninWithAppleButton_scss_json_1.default.icon, viewBox: "-1.5 0 20 20" },
            react_1.default.createElement("path", { d: "M11.570887 3.19296C12.29996 2.34797 12.791401 1.17098 12.656912 0c-1.050633.04-2.321706.67099-3.075048 1.51498-.67649.74899-1.267029 1.94597-1.10827 3.09396 1.171976.08699 2.36822-.57 3.097293-1.41598m2.6281 7.43189C14.22831 13.65181 16.969663 14.65879 17 14.67179c-.022246.071-.437848 1.43498-1.443988 2.84496-.87064 1.21799-1.773639 2.43097-3.196392 2.45697-1.397473.025-1.847455-.79399-3.446157-.79399-1.59769 0-2.09722.76799-3.419865.81899-1.373205.049-2.419793-1.31798-3.2965-2.53196C.403236 14.98379-.966935 10.44985.873442 7.3899c.914121-1.51898 2.547203-2.48197 4.320842-2.50597 1.347924-.025 2.62102.86899 3.445145.86899s2.371256-1.07499 3.99726-.91699c.680534.027 2.591695.263 3.818276 1.98397-.099097.059-2.280247 1.27499-2.255979 3.80495", fillRule: "evenodd" })) }, restProps), label));
};
exports.SigninWithAppleButton = SigninWithAppleButton;
//# sourceMappingURL=SigninWithAppleButton.js.map